import React from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import Reporting from "../pages/Reporting";
import Dashboard from "../pages/Dashboard";
import Unbind from "../pages/Unbind";
import OnboardMerchantPage from "../pages/OnboardMerchantPage";
import CreateTerminalPage from "../pages/CreateTerminalPage";
import Merchants from "../pages/merchants";
import Terminals from "../pages/terminals";
import Users from "../pages/users";
import CreateUser from "../pages/CreateUsers";
import Operations from "../pages/Operations";
import Inventory from "../pages/Inventory";
import HardPOS from "../pages/HardPOS";

function DashboardLayout() {
  const location = useLocation();

  // derive title from current route
  let pageTitle = "Dashboard";
  let mode = "create"; 
  if (location.pathname.includes("reporting")) {
    pageTitle = "Reporting";
  } else if (location.pathname.includes("unbind")) {
    pageTitle = "Unbind Terminal";
  } else if (location.pathname.includes("terminalslist")) {
    pageTitle = "All Terminals";
  } else if (location.pathname.includes("terminal")) {
   const params = new URLSearchParams(location.search);
    mode = params.get("mode") || "create";

    if (mode === "edit") pageTitle = "Edit Terminal";
    else if (mode === "view") pageTitle = "View Terminal";
    else pageTitle = "Create New Terminal";
  } else if (location.pathname.includes("merchantslist")) {
    pageTitle = "All Merchants";
  } else if (location.pathname.includes("merchant")) {
    const params = new URLSearchParams(location.search);
    mode = params.get("mode") || "create";

    if (mode === "edit") pageTitle = "Edit Merchant";
    else if (mode === "view") pageTitle = "View Merchant";
    else  pageTitle = "Merchant Onboarding";
    
  }else if (location.pathname.includes("userslist")) {
    pageTitle = "All Users";
  } else if (location.pathname.includes("operations")) {
    pageTitle = "Operations";
  } else if (location.pathname.includes("hardpos")) {
    pageTitle = "Hard POS";
  }else if (location.pathname.includes("inventory")) {
    pageTitle = "Inventory";
  }else if (location.pathname.includes("user")) {
    const params = new URLSearchParams(location.search);
    mode = params.get("mode") || "create";

    if (mode === "edit") pageTitle = "Edit user";
    else if (mode === "view") pageTitle = "View User";
    else  pageTitle = "Add New User";
    
  }

  return (
    <div className="dashboard-layout">
      {/* Sidebar always visible */}
      <Sidebar isOpen={true} />

      <div className="dashboard-main">
        {/* Navbar stays on top */}
        <Navbar title={pageTitle} />

        {/* Swappable content */}

        <div className="dashboard-content">
          {location.pathname.includes("reporting") ? (
            <Reporting isSidebarOpen={true} />
          ) : location.pathname.includes("unbind") ? (
            <Unbind isSidebarOpen={true} />
          ) : location.pathname.includes("merchantslist") ? (
            <Merchants isSidebarOpen={true} />
          ) : location.pathname.includes("merchant") ? (
            <OnboardMerchantPage isSidebarOpen={true} mode={mode} />
          ) : location.pathname.includes("terminalslist") ? (
            <Terminals isSidebarOpen={true} />
          ): location.pathname.includes("terminal") ? (
            <CreateTerminalPage isSidebarOpen={true} mode={mode}/>
          ): location.pathname.includes("userslist") ? (
            <Users isSidebarOpen={true} />
          ): location.pathname.includes("hardpos") ? (
            <HardPOS isSidebarOpen={true} />
          ): location.pathname.includes("inventory") ? (
            <Inventory isSidebarOpen={true} />
          ): location.pathname.includes("user") ? (
            <CreateUser isSidebarOpen={true} mode={mode}/>
          ): location.pathname.includes("operations") ? (
            <Operations isSidebarOpen={true} />
          ) : (
            <Dashboard isSidebarOpen={true} />
          )}
        </div>
      </div>
    </div>
  );
}

export default DashboardLayout;
